import e from "react";
import { EnvironmentProvider as g } from "../../../features/common/hooks/environment/context.js";
import { useAuth as u } from "../../../features/auth/hooks/useAuth.js";
import { AuthProvider as h } from "../../../features/auth/components/AuthProvider/AuthProvider.js";
import { useAction as f } from "../../../features/landing/hooks/useAction.js";
import { Navbar as v } from "../../../features/landing/components/Navbar/Navbar.js";
import { SharedLandingBody as b } from "./SharedLandingBody.js";
import { SharedLandingShell as E } from "./SharedLandingShell.js";
import { mapSharedLandingDesignToNavbar as S } from "./utils.js";
import { SharedLandingFooter as A } from "./SharedLandingFooter.js";
function L(t) {
  const {
    rotative: r,
    buttons: i,
    design: n,
    children: o,
    utmReferral: c
  } = t, {
    customer: a
  } = u(), {
    actionButtons: s
  } = f(
    i,
    [],
    {
      overrideHistory: !0,
      utmReferral: c
    }
  ), m = (p) => p.replace(/\*\|customer_name\|\*/, (a == null ? void 0 : a.profile.firstName) ?? ""), d = r.titles.map(m), l = r.subtitles.map(m);
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    b,
    {
      design: n,
      rotative: {
        titles: d,
        subtitles: l
      },
      buttons: s,
      utmReferral: c
    },
    o
  ), /* @__PURE__ */ e.createElement(A, { design: n }));
}
function N({
  guest: t,
  authenticated: r,
  children: i,
  scope: n,
  utmReferral: o
}) {
  const {
    customer: c
  } = u(), a = c ? r : t, {
    navbar: s,
    design: m,
    backgroundImage: d,
    background640x1100: l
  } = a;
  return /* @__PURE__ */ e.createElement(
    E,
    {
      backgroundImage: d,
      background640x1100: l,
      design: m
    },
    /* @__PURE__ */ e.createElement(
      v,
      {
        ...s,
        utmReferral: o,
        scope: n,
        design: S(m)
      },
      /* @__PURE__ */ e.createElement(L, { ...a, utmReferral: o }, i)
    )
  );
}
function C(t) {
  const {
    env: r,
    authScope: i,
    portalId: n,
    onAuthChange: o
  } = t;
  return /* @__PURE__ */ e.createElement(g, { env: r }, /* @__PURE__ */ e.createElement(h, { scope: i, portalId: n, onAuthChange: o }, /* @__PURE__ */ e.createElement(N, { ...t })));
}
export {
  C as AuthSharedLanding
};
//# sourceMappingURL=AuthSharedLanding.js.map
